export default {
    setReservas(state, a) {
        state.reservas = a;
    },
    setReservasNoConfirmada(state, r) {
        state.reservasNoConfirmada = r;
    }
}